var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('hr',{class:_setup.dividerRecipe({ variant: _setup.props.variant }),attrs:{"data-component":"CsDivider"}})
}
var staticRenderFns = []

export { render, staticRenderFns }